export const modalTypes = {
    questionsOnScale:'questionsOnScale',
    freeAnswer:'freeAnswer',
    questionsChoiceOfOptionsMany:'questionsChoiceOfOptionsMany',
    questionsChoiceOfOptionsOne:'questionsChoiceOfOptionsOne',
}